module.exports = __webpack_public_path__ + "static/2-messenger_toast-7dc4d78fc9dc3e6bb5685869c012e5c7.png";